import { INetwork } from './types';

export const NETWORKS: INetwork[] = [
  { provider: 'twitter', name: 'Twitter', auth: true },
  { provider: 'linkedin', name: 'LinkedIn', auth: true },
  { provider: 'facebook', name: 'Facebook', auth: false },
];
